<script setup lang="ts">
const modalsStore = useModalsStore();

function handleOnClose() {
    modalsStore.modals.ImagePreview.img = '';
    modalsStore.closeModal('ImagePreview');
};
</script>

<template>
    <ModalsBase 
        :isOpen="modalsStore.modals.ImagePreview.isOpen" 
        closeOnClickOutside
        @close="handleOnClose"
    >
        <div class="w-full pt-5">
            <img 
                :src="modalsStore.modals.ImagePreview.img"
                :alt="modalsStore.modals.ImagePreview.title"
                class="max-h-[70vh] max-w-full mx-auto object-cover"
            >
        </div>
    </ModalsBase>
</template>